import React, { useState, useEffect, useCallback } from "react";
import style from "./style.module.scss";

const Currency = ({ valueChange, value, disabled, required, label, isAllowed, ...rest }) => {
  const [rawvalue, setrawValue] = useState("");
  const [formattedValue, setformattedValue] = useState("");
  const [timeoutId, settimeoutId] = useState(null);

  const updateValues = useCallback(
    (__numeric_str, __should_trigger_change = true) => {
      const _clean_str = __numeric_str.replace(/^0+/, "") || "0";
      const _numeric_val = parseInt(_clean_str, 10) || 0;
      const _final_val = _numeric_val / 100;

      const _formatted =
        _numeric_val === 0 && rawvalue === ""
          ? ""
          : `R$ ${_final_val
              .toFixed(2)
              .replace(".", ",")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;

      setrawValue(_clean_str === "0" ? "" : _clean_str);
      setformattedValue(_formatted);
      if (__should_trigger_change) {
        valueChange(_final_val);
      }
    },
    [rawvalue, valueChange],
  );

  useEffect(() => {
    if (value !== undefined && value !== null) {
      const _new_raw_value = (value * 100).toFixed(0);
      updateValues(_new_raw_value, false);
    } else {
      setrawValue("");
      setformattedValue("");
    }
  }, [value, updateValues]);

  const handleChange = __ev => {
    let _value = __ev?.target?.value;
    _value = _value.replace(/[^\d]/g, "");
    _value = Number(_value) / 100;
    const _is_allowed = !isAllowed ? true : isAllowed(_value);
    if (!_is_allowed) {
      __ev.preventDefault();
      return false;
    }
    const _numeric_str = __ev.target.value.replace(/\D/g, "");

    // Debounce
    if (timeoutId) clearTimeout(timeoutId);
    const newTimeoutId = setTimeout(() => {
      updateValues(_numeric_str);
    }, 60);
    settimeoutId(newTimeoutId);
  };

  return (
    <div className={style.input} data-label={!!label}>
      <span className={style.label}>{label}</span>
      <input
        type="text"
        value={formattedValue}
        rawvalue={rawvalue}
        onChange={handleChange}
        placeholder="R$ 0,00"
        disabled={disabled}
        data-required={required}
        data-required-valid={required && !!value}
        autoComplete="off"
        {...rest}
      />
    </div>
  );
};

export default Currency;
